module.exports = __webpack_public_path__ + "static/media/1009863.b2341ddc.jpg";